import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { defaultLocale } from './i18n';
import { BASE_URL as baseUrl } from 'constants/app';

export const HreflangTags = () => {
    const { pathname } = useLocation();
    const { i18n } = useTranslation();
    const allLocales = i18n.options.languages || [];

    // Извлекаем чистый путь без языкового префикса
    const segments = pathname.split('/').filter(Boolean);
    const hasLocalePrefix = allLocales.includes(segments[0]) && segments[0] !== defaultLocale;
    const cleanPath = hasLocalePrefix ? `/${segments.slice(1).join('/')}` : pathname;
    const path = cleanPath === '/' ? '' : cleanPath;

    return (
        <Helmet>
            {/* Основная версия и x-default */}
            <link rel="alternate" href={`${baseUrl}${path}`} hreflang={defaultLocale} />
            <link rel="alternate" href={`${baseUrl}${path}`} hreflang="x-default" />
            
            {/* Версии с префиксами */}
            {allLocales.filter(l => l !== defaultLocale).map((locale) => (
                <link 
                    key={locale}
                    rel="alternate" 
                    href={`${baseUrl}/${locale}${path}`} 
                    hreflang={locale} 
                />
            ))}
        </Helmet>
    );
};

export default HreflangTags;